/* eslint-disable */
import { connect } from 'react-redux';
import moment from 'moment';
import { modalActions } from '../../../Actions';
import { BaseModal } from '../BaseModal';
import styles from './OrderItemsModal.module.scss';
import { urls } from '../../../Constants';
import { classes } from '../../../Helpers';
import DynamicHeaderTable from '../../DynamicHeaderTable/DynamicHeaderTable';
import locateIcon from '../../../Images/locate.svg';

// Every traceability timestamp except origStockedInAt is nullable, and moment(undefined) silently
// renders "now" - so nulls have to be caught before formatting, not after.
const DATE_TIME_COLS = ['origStockedInAt', 'thawingTime', 'stockedOutAt'];

const formatDateTime = (value) => {
	if (!value) {
		return '-';
	}
	return moment(value).format('YYYY-MM-DD HH:mm A');
};

// A negative duration means the unit was stocked out BEFORE its thawing stamp, so the two values
// contradict each other. Neither half is trustworthy on its own, so both the duration and the
// thawing start are suppressed rather than publishing one of them as if it were sound.
const hasContradictoryThawing = (ele) => {
	const minutes = ele?.thawingDurationMinutes;
	if (minutes === null || minutes === undefined) {
		return false;
	}
	const total = Number(minutes);
	return !Number.isNaN(total) && total < 0;
};

// thawingDurationMinutes is null whenever the unit was never stamped as thawing.
const formatDuration = (minutes) => {
	if (minutes === null || minutes === undefined || Number.isNaN(Number(minutes))) {
		return '-';
	}
	const total = Number(minutes);
	if (total < 0) {
		return '-';
	}
	const hours = Math.floor(total / 60);
	const mins = total % 60;
	return hours > 0 ? `${hours}h ${mins}m` : `${mins}m`;
};

const OrderItemsModal = (props) => {
	const { show, data, toggleModal } = props;

	const handleClose = () => {
		toggleModal(false);
	};

	const getSubColumnsValues = ({ colId, rowItem }) => {
		if (colId === 2) {
			return rowItem?.count;
		}
		if (typeof colId !== 'number') {
			if (!rowItem?.traceability?.length) {
				return (
					<div className={styles.fields}>
						-
					</div>
				);
			}
			return (
				<div className={styles.fields}>
					{rowItem?.traceability?.map((ele) => {
						if (DATE_TIME_COLS.includes(colId)) {
							const suppress = colId === 'thawingTime'
								&& hasContradictoryThawing(ele);
							return (
								<div className={styles.field}>
									{suppress ? '-' : formatDateTime(ele?.[colId])}
								</div>
							);
						}
						if (colId === 'thawingDurationMinutes') {
							return (
								<div className={styles.field}>
									{formatDuration(ele?.thawingDurationMinutes)}
								</div>
							);
						}
						return (
							<div className={classes(styles.field, styles.redirect_container)}>
								{colId === 'trace' ? (
									<div
										onClick={() => {
											window.open(
												// eslint-disable-next-line prefer-template
												urls.EXTENSION +
													urls.ORDER_TRACKNG +
													'?type=qrCode&value=' +
													ele?.qrCode,
												'_blank'
											);
										}}
										className={styles.redirect}
									>
										<p>Click here</p>
										<img src={locateIcon} alt='loate' />
									</div>
								) : (
									ele?.[colId] ?? '-'
								)}
							</div>
						);
					})}
				</div>
			);
		}
		return '-';
	};

	return (
		<BaseModal
			heading={`Order items of ${data?.orderId}`}
			width='85rem'
			height='40rem'
			open={show}
			handleClose={handleClose}
			showConfirm={false}
		>
			{data?.items?.length <= 0 ? <div>No items</div> : <></>}
			<DynamicHeaderTable
				headerData={[
					{
						colName: 'Name & Variant',
						id: 1,
						subCols: [],
					},
					{
						colName: 'Count',
						id: 2,
						subCols: [],
					},
					{
						colName: 'Traceability',
						id: 3,
						subCols: [
							{
								colName: 'Quantity',
								id: 'qty',
								subCols: [],
							},
							{
								colName: 'Manufactured At',
								id: 'origStockedInAt',
								subCols: [],
							},
							{
								colName: 'Last Asset',
								id: 'lastAssetName',
								subCols: [],
							},
							{
								colName: 'Thawing Start',
								id: 'thawingTime',
								subCols: [],
							},
							{
								colName: 'Thawing Duration',
								id: 'thawingDurationMinutes',
								subCols: [],
							},
							{
								colName: 'Stocked Out At',
								id: 'stockedOutAt',
								subCols: [],
							},
							{
								colName: 'Trace Item',
								id: 'trace',
								subCols: [],
							},
						],
					},
				]}
				rowsData={data?.items?.map((ele) => {
					return {
						...ele,
						// eslint-disable-next-line prefer-template
						name: ele?.name + '(' + ele?.variant + ')',
						id: ele?.itemId,
					};
				})}
				excludedCols={['Name & Variant']}
				tableDataElement={getSubColumnsValues}
			/>
		</BaseModal>
	);
};

const mapStateToProps = (state) => {
	const { show, data } = state.modal.orderItemsModal;
	return {
		show,
		data,
	};
};

const mapDispatchToProps = {
	toggleModal: modalActions.toggleOrderItemsModal,
};
export default connect(mapStateToProps, mapDispatchToProps)(OrderItemsModal);
